module.exports = __webpack_public_path__ + "static/img/6629_phase_function_Paper_Points.2c4cd74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6629_phase_function_Paper_Points.png
// module id = 2Maw
// module chunks = 0